import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import compose from '../../hoc/compose';
import tooltipPositionUtil from '../../util/tooltipPosition';
import withClickOutside from '../../hoc/withClickOutside';
import Bubble from '../bubble';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getRectByReactElement } from '../../util/rect';
import Portal from '../portal';

var rectToStyle = function rectToStyle(rect) {
  return {
    top: rect.y,
    left: rect.x,
    height: rect.height,
    width: rect.width,
    zIndex: rect.zIndex
  };
};

var addMargins = function addMargins(props, trigger) {
  return {
    x: trigger.x - props.marginLeft,
    y: trigger.y - props.marginTop,
    width: trigger.width + props.marginLeft + props.marginRight,
    height: trigger.height + props.marginTop + props.marginBottom
  };
};

var MOUSE_TRIGGER_MARGIN = 5;

var getMouseTrigger = function getMouseTrigger(x, y) {
  return {
    x: x - MOUSE_TRIGGER_MARGIN,
    y: y - MOUSE_TRIGGER_MARGIN,
    width: MOUSE_TRIGGER_MARGIN * 2,
    height: MOUSE_TRIGGER_MARGIN * 2
  };
};

var INTERACTIVE_DELAY = 200;
var ANIMATION_DURATION = 200;

var shouldBeOpen = function shouldBeOpen(props, state) {
  return !props.disabled && (props.isOpen || state.isOpen);
};

var CLOSED_STATE = {
  isOpen: false,
  contentStyle: {},
  arrowStyle: {},
  arrowAlignment: '',
  x: 0,
  y: 0
};

var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.state = CLOSED_STATE;
    _this.timers = [];
    _this.clickOutsideHandlerId = null;

    _this.open = function () {
      return _this.setState({
        isOpen: true
      });
    };

    _this.close = function () {
      _this.setState(_.isUndefined(_this.props.isOpen) ? CLOSED_STATE : {
        isOpen: false
      });
    };

    _this.isOpen = function () {
      return shouldBeOpen(_this.props, _this.state);
    };

    _this.mountPoint = null;

    _this.setMountPoint = function () {
      if (!_this.mountPoint) {
        _this.mountPoint = window.document.createElement('div');
        window.document.body.appendChild(_this.mountPoint);

        _this.setState({
          isPortalOpened: true,
          displayTooltipContent: true
        });
      }
    };

    _this.onClose = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.unregisterOnOuterClick = function () {
      if (_this.clickOutsideHandlerId) {
        _this.props.clearOnClickOutside(_this.clickOutsideHandlerId);

        _this.clickOutsideHandlerId = null;
      }
    };

    _this.removeMountPoint = function () {
      if (_this.mountPoint) {
        window.document.body.removeChild(_this.mountPoint);
        _this.mountPoint = null;

        _this.setState({
          isPortalOpened: false,
          contentStyle: {}
        });

        _this.onClose();

        _this.unregisterOnOuterClick();
      }
    };

    _this.getTrigger = function () {
      if (_this.props.customTrigger && _this.props.positionByCustomTrigger) {
        return _this.props.customTrigger;
      }

      return _.head(ReactDOM.findDOMNode(_assertThisInitialized(_this)).children);
    };

    _this.onLayoutChange = function (contentRef) {
      var viewport = tooltipPositionUtil.getViewportSize();
      var contentRect = getRectByReactElement(contentRef);

      var trigger = _(_this.getTrigger()).thru(getRectByReactElement).thru(_.partial(addMargins, _this.props)).value();

      var mouseTrigger = addMargins(props, getMouseTrigger(_this.state.x, _this.state.y));
      var CONSTS = tooltipPositionUtil.CONSTS;
      var params = {
        alignment: _this.props.alignment || CONSTS.ALIGNMENT.TOP,
        arrowDistance: _this.props.arrowDistance
      };
      var triggerRect = _this.props.positionByMouse ? mouseTrigger : trigger;
      var initialPosition = tooltipPositionUtil.getContentPosition(viewport, triggerRect, contentRect, params);

      var _tooltipPositionUtil$ = tooltipPositionUtil.getFinalPositions(viewport, triggerRect, initialPosition, params),
          content = _tooltipPositionUtil$.content,
          arrow = _tooltipPositionUtil$.arrow;

      content.zIndex = _this.props.zIndex;
      arrow.zIndex = _this.props.zIndex;
      var arrowAlignment; // eslint-disable-next-line wix-editor/prefer-ternary

      if (tooltipPositionUtil.isVerticalAlignment(params)) {
        arrowAlignment = arrow.y === content.y ? 'top' : 'bottom';
      } else {
        arrowAlignment = arrow.x === content.x ? 'left' : 'right';
      }

      var contentStyle = _(content).thru(rectToStyle).omit(['width', 'height']).assign({
        maxWidth: _this.props.maxWidth
      }).value();

      if (!_.isEqual(contentStyle, _this.state.contentStyle)) {
        _this.setState({
          contentStyle: contentStyle,
          arrowStyle: rectToStyle(arrow),
          arrowAlignment: arrowAlignment
        });
      }
    };

    _this.getBubbleProps = function () {
      return _.assign({
        ref: function ref(_ref) {
          _this.bubble = _ref;
        }
      }, _this.props, _this.state, {
        className: 'tooltip',
        onLayoutChange: _this.onLayoutChange,
        maxWidth: _this.props.maxWidth,
        targetContent: _this.props.children,
        dataHook: 'bubble-content'
      }, _this.props.interactive ? {
        onMouseEnter: _this.onMouseEnter,
        onMouseLeave: _this.onMouseLeave,
        onClick: _this.onContentMouseClick
      } : {});
    };

    _this.onOpen = function () {
      if (_this.props.onOpen) {
        _this.props.onOpen();
      }
    };

    _this.registerOnOuterClick = function () {
      if (_.isFunction(_this.props.onOuterClick)) {
        _this.clickOutsideHandlerId = _this.props.onClickOutside(function (e) {
          return _this.props.onOuterClick(e);
        }, _this.setMountPoint());
      }
    };

    _this.openPortal = function () {
      _this.timers.forEach(function (timer) {
        return window.clearTimeout(timer);
      });

      _this.setMountPoint();

      if (!_.isEmpty(_this.state.contentStyle)) {
        _this.onOpen();

        _this.registerOnOuterClick();
      }
    };

    _this.onScroll = function (e) {
      if (_.isFunction(_this.props.onScroll)) {
        _this.props.onScroll(e);
      }

      if (_this.isOpen()) {
        _this.close();
      }
    };

    _this.onClick = function () {
      if (_this.props.closeOnMouseClick && !_this.props.customTrigger) {
        _this.close();
      }
    };

    _this.onContentMouseClick = function () {
      if (_this.props.onContentMouseClick) {
        _this.props.onContentMouseClick();
      }

      if (_this.props.closeOnContentMouseClick && !_this.props.customTrigger) {
        _this.close();
      }
    };

    _this.onMouseEnter = function () {
      if (_this.props.openOnMouseEnter && !_this.props.customTrigger && !_this.props.positionByMouse) {
        if (_this.props.interactive) {
          window.clearTimeout(_this.closeTimer);

          _this.open();
        } else {
          _this.open();
        }
      }
    };

    _this.onMouseLeave = function () {
      window.clearTimeout(_this.openTimeout);

      if (_this.props.closeOnMouseLeave && !_this.props.customTrigger) {
        if (_this.props.interactive) {
          _this.closeTimer = window.setTimeout(function () {
            return _this.close();
          }, INTERACTIVE_DELAY);
        } else {
          _this.close();
        }
      }
    };

    _this.onMouseMove = function (event) {
      if (_this.props.positionByMouse) {
        _this.removeMountPoint();

        _this.close();

        _this.setState({
          isOpen: true,
          x: event.clientX,
          y: event.clientY
        });
      }
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "openDelayedPortal",
    value: function openDelayedPortal() {
      var _this2 = this;

      if (this.props.openDelay) {
        window.clearTimeout(this.openTimeout);
        this.openTimeout = window.setTimeout(function () {
          _this2.openPortal();
        }, this.props.openDelay);
      } else {
        this.openPortal();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpen()) {
        this.openDelayedPortal();
      }

      window.addEventListener('wheel', this.onScroll);
      window.addEventListener('scroll', this.onScroll);
      this.registerCustomTrigger(this.props.customTrigger);
    }
  }, {
    key: "unregisterCustomTrigger",
    value: function unregisterCustomTrigger() {
      if (this.props.customTrigger) {
        var customTrigger = ReactDOM.findDOMNode(this.props.customTrigger);

        if (customTrigger && this.props.openOnMouseEnter) {
          customTrigger.removeEventListener('mouseenter', this.open);
        }

        if (customTrigger && this.props.closeOnMouseLeave) {
          customTrigger.removeEventListener('mouseleave', this.close);
        }
      }
    }
  }, {
    key: "registerCustomTrigger",
    value: function registerCustomTrigger(customTrigger) {
      if (!customTrigger) {
        return;
      }

      var customTriggerNode = ReactDOM.findDOMNode(customTrigger);

      if (customTriggerNode && this.props.openOnMouseEnter) {
        customTriggerNode.addEventListener('mouseenter', this.open);
      }

      if (customTriggerNode && this.props.closeOnMouseLeave) {
        customTriggerNode.addEventListener('mouseleave', this.close);
      }
    }
    /*
    In order to achieve a fade-out transition effect, removing the tooltip includes 2 steps:
    1. Remove the content of the tooltip
    2. Wait for the effect to kick in and only then remove the container of the tooltip
    */

  }, {
    key: "removeTooltipWithTransition",
    value: function removeTooltipWithTransition() {
      var _this3 = this;

      this.setState({
        displayTooltipContent: false
      });
      this.timers.push(window.setTimeout(function () {
        _this3.removeMountPoint();
      }, ANIMATION_DURATION));
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var customTriggerHasChanged = this.props.customTrigger && this.props.customTrigger !== nextProps.customTrigger;

      if (customTriggerHasChanged) {
        this.unregisterCustomTrigger();
      }
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      var _this4 = this;

      if (this.isOpen() && !shouldBeOpen(nextProps, nextState)) {
        var waitBeforeTooltipClose = this.props.animationDuration;
        var timeout = waitBeforeTooltipClose ? waitBeforeTooltipClose - ANIMATION_DURATION : 0;
        this.timers.push(window.setTimeout(function () {
          _this4.removeTooltipWithTransition();
        }, timeout));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.isOpen()) {
        this.openDelayedPortal();
      }

      var customTriggerHadChanged = prevProps.customTrigger !== this.props.customTrigger;

      if (customTriggerHadChanged) {
        this.registerCustomTrigger(this.props.customTrigger);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('wheel', this.onScroll);
      this.timers.forEach(function (timer) {
        return window.clearTimeout(timer);
      });
      window.clearTimeout(this.closeTimer);
      window.clearTimeout(this.openTimeout);
      this.removeMountPoint();
      this.unregisterCustomTrigger();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName('has-tooltip'),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseMove: this.onMouseMove
      }, this.props.customTrigger && !this.props.displayCustomTrigger ? null : this.props.children), this.state.isPortalOpened ? /*#__PURE__*/React.createElement(Portal, {
        key: "tooltip-portal",
        container: this.mountPoint,
        ref: function ref(_ref2) {
          _this5.tooltipPortal = _ref2;
        }
      }, /*#__PURE__*/React.createElement(CSSTransitionGroup, {
        transitionName: "tooltip",
        transitionEnter: false,
        transitionLeaveTimeout: ANIMATION_DURATION
      }, this.state.displayTooltipContent && /*#__PURE__*/React.createElement(Bubble, _extends({
        key: "bubble-content"
      }, this.getBubbleProps()), this.props.content))) : null);
    }
  }], [{
    key: "ANIMATION_DURATION",
    get: function get() {
      return ANIMATION_DURATION;
    }
  }, {
    key: "INTERACTIVE_DELAY",
    get: function get() {
      return INTERACTIVE_DELAY;
    }
  }]);

  return Tooltip;
}(React.Component);

Tooltip.displayName = 'Tooltip';
var nodeType = PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired, PropTypes.element.isRequired]);
Tooltip.propTypes = {
  /** align the tooltip: 'TOP','BOTTOM','LEFT' or 'RIGHT' */
  alignment: PropTypes.oneOf(['TOP', 'BOTTOM', 'LEFT', 'RIGHT']),

  /** the duration for the tooltip to be close. triggered only after hovering the content itself*/
  animationDuration: PropTypes.number,

  /** the tooltip arrow distance from it */
  arrowDistance: PropTypes.number,

  /** should close tooltip on clicking attached component */
  closeOnMouseClick: PropTypes.bool,

  /** should close tooltip on clicking its content */
  closeOnContentMouseClick: PropTypes.bool,

  /** should close tooltip on mouse leave */
  closeOnMouseLeave: PropTypes.bool,

  /** tooltip content */
  content: nodeType,
  customTrigger: PropTypes.object,
  // React ref
  direction: PropTypes.string,

  /** disables tooltip appearance */
  disabled: PropTypes.bool,
  displayCustomTrigger: PropTypes.bool,

  /** an interactive tooltip */
  interactive: PropTypes.bool,

  /** is tooltip open */
  isOpen: PropTypes.bool,

  /** the bottom margin from the tooltip to its child/attached component */
  marginBottom: PropTypes.number,

  /** the top margin from the tooltip to its child/attached component */
  marginTop: PropTypes.number,

  /** the left margin from the tooltip to its child/attached component */
  marginLeft: PropTypes.number,

  /** the right margin from the tooltip to its child/attached component */
  marginRight: PropTypes.number,

  /** tooltip max content width */
  maxWidth: PropTypes.number,

  /** a callback to called on tooltip closed */
  onClose: PropTypes.func,

  /** a callback to called on click outside the tooltip */
  onOuterClick: PropTypes.func,

  /** a callback to called on tooltip opended */
  onOpen: PropTypes.func,

  /** a callback to called on page scroll */
  onScroll: PropTypes.func,

  /** show tooltip on mouse enter the attached component */
  openOnMouseEnter: PropTypes.bool,
  positionByCustomTrigger: PropTypes.bool,

  /** attach tooltip to mouse */
  positionByMouse: PropTypes.bool,

  /** tooltip z index */
  zIndex: PropTypes.number,

  /** the delay before showing the tooltip (on miliseconds) */
  openDelay: PropTypes.number,

  /** show tooltip as hint (responsive only) */
  isHint: PropTypes.bool,

  /** handle click event on content area (responsive only) */
  onContentMouseClick: PropTypes.func
};
Tooltip.defaultProps = {
  closeOnMouseClick: false,
  closeOnMouseLeave: true,
  disabled: false,
  displayCustomTrigger: false,
  interactive: false,
  marginBottom: 0,
  marginLeft: 0,
  marginTop: 0,
  marginRight: 0,
  maxWidth: 240,
  openOnMouseEnter: true,
  positionByCustomTrigger: true,
  positionByMouse: false,
  zIndex: 5999,
  openDelay: 0
};
export default compose(Tooltip, [withClickOutside]);